// extracted by mini-css-extract-plugin
export var fastFactsColumns = "fast-facts-columns-module--fast-facts-columns--7beff";
export var fastFactsColumns__body = "fast-facts-columns-module--fast-facts-columns__body--15bd2";
export var fastFactsColumns__cardEven = "fast-facts-columns-module--fast-facts-columns__card--even--9058b";
export var fastFactsColumns__item = "fast-facts-columns-module--fast-facts-columns__item--d15bc";
export var mt0 = "fast-facts-columns-module--mt-0--f6c75";
export var mt1 = "fast-facts-columns-module--mt-1--d5ec5";
export var mt2 = "fast-facts-columns-module--mt-2--9f25e";
export var mt3 = "fast-facts-columns-module--mt-3--970ad";
export var mt4 = "fast-facts-columns-module--mt-4--08ed6";
export var mt5 = "fast-facts-columns-module--mt-5--a455d";
export var mt6 = "fast-facts-columns-module--mt-6--371f3";